import {ISelectOption} from '../core/_model'

// Format Options Selection
export const mapToSelectOptions = <T>(
  data: T[],
  config: {idKey: keyof T; labelKey: keyof T; valueKey: keyof T}
): ISelectOption[] => {
  const {idKey, labelKey, valueKey} = config

  return data.map((item) => ({
    id: Number(item[idKey]),
    label: String(item[labelKey]),
    value: String(item[valueKey]),
  }))
}

// Get value name from an given array
export const getValueById = <T extends {id: number}, K extends keyof T>(
  data: T[],
  id: number,
  key: K
): T[K] | '' => {
  const selected = data.find((d) => d.id === id)
  return selected ? selected[key] : ''
}
